import React,{useEffect, useState} from 'react';

import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { useAccount, useConnect, useDisconnect } from 'wagmi'

export default function Package(){
  const { address, isConnected } = useAccount()
  const [adrs , setAddress] = useState()

useEffect(()=>{
  setAddress(address)
},[address])

function copyToClipboard(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    document.execCommand('copy');
    console.log('Text copied to clipboard');
    Swal.fire(
      'Code Copied to Clipboard',
      // 'success'
    )
  } catch (err) {
    console.error('Unable to copy:', err);
  } finally {
    document.body.removeChild(textarea);
  }
}


const referral = () => {


  Swal.fire({
    title: 'Your Referral is',
    text: `https://globuschain.com/?referral=${address.substring(0, 6)}`,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Copy Referral'
  }).then((result) => {
    if (result.isConfirmed) {
      copyToClipboard(`https://globuschain.com/?referral=${address}`)
    }
  })

 
}



    return(
        <section className="pt-120 pb-120">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-6 text-center">
        <div className="section-header">
          <h2 className="section-title">
            <span className="font-weight-normal">Task</span>{" "}
            <b className="base--color">Plans</b>
          </h2>
          <p>
            To make a solid Task, you have to know where you are
            investing. Find a plan which is best for you.
          </p>
        </div>
      </div>
    </div>
    {/* row end */}


          <div
            style={{ border: '3px solid #cca354' }}
            className="subscribe-wrapper bg_img mb-5"
          >
            <div className="align-items-center">
              <div style={{ textAlign: 'center' }}>
                <h2 className="title">Enter your crypto wallet address <div className="package-card__range base--color">
                  1 Entry
                </div></h2>
              </div>
              <div className="">
                <form className="subscribe-form">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Crypto Address"
                  />
                  <button className="subscribe-btn">
                  💳
                  </button>
                </form>

              </div>
            </div>
          </div>


    <div className="row justify-content-center mb-none-30">
      {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Facebook</h4>
     
          <ul className="package-card__features mt-4 account-menu ">

          <li className="icon">
               
               <i  style={{marginLeft:'auto' , marginRight:'auto' , marginTop:'50px' , marginBottom :'50px'}}  className="lab la-facesbook-f" />
             
           </li>

          </ul>
          <div className="package-card__range mt-5 base--color">Task 1</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Instagram</h4>
     
          <ul className="package-card__features mt-4 account-menu ">

          <li className="icon">
               
               <i  style={{marginLeft:'auto' , marginRight:'auto' , marginTop:'50px' , marginBottom :'50px'}}  className="lab la-square-instagram" />
             
           </li>

          </ul>
          <div className="package-card__range mt-5 base--color">Task 2</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Twitter</h4>
     
          <ul className="package-card__features mt-4 account-menu ">

          <li className="icon">
               
               <i  style={{marginLeft:'auto' , marginRight:'auto' , marginTop:'50px' , marginBottom :'50px'}}  className="lab la-twitter-t" />
             
           </li>

          </ul>
          <div className="package-card__range mt-5 base--color">Task 3</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Referral</h4>
     
          <ul className="package-card__features mt-4 account-menu ">

          <li className="icon">
               
               <i  style={{marginLeft:'auto' , marginRight:'auto' , marginTop:'50px' , marginBottom :'50px'}}  className="lab la-twitter-f" />
             
           </li>

          </ul>
          <div className="package-card__range mt-5 base--color">Task 4</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div> */}
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Twitter</h4>
          <ul  className="package-card__features mt-4">
            {/* <li>Return 1.1USD</li>
            <li>Every Day</li>
            <li>For 50 Day</li>
            <li>
              Total 55USD + <span className="badge base--bg">Capital</span>
            </li> */}
            <li>Follow GlobusChain on Twitter </li>
          </ul>
          <div className="package-card__range mt-5 base--color">
          1 Entry
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
     
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Twitter </h4>
          <ul className="package-card__features mt-4">
            <li>Tweet about GlobusCain and tag Elon Musk </li>
            {/* <li>Every Hour</li>
            <li>For 150 Hour</li>
            <li>
              Total 1500USD + <span className="badge base--bg">Capital</span>
            </li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">5 Entries</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Discord</h4>
          <ul className="package-card__features mt-4">
            <li>Join the GlobusChain discord</li>
            {/* <li>Every Day</li>
            <li>For Lifetime</li>
            <li>Lifetime Earning</li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">
            1 Entry
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Telegram </h4>
          <ul className="package-card__features mt-4">
            <li>Join the GlobusChain on telegram</li>
            {/* <li>Every Day</li>
            <li>For Lifetime</li>
            <li>Lifetime Earning</li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">
            1 Entry
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>


      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Share</h4>
          <ul  className="package-card__features mt-4">
            {/* <li>Return 1.1USD</li>
            <li>Every Day</li>
            <li>For 50 Day</li>
            <li>
              Total 55USD + <span className="badge base--bg">Capital</span>
            </li> */}
            <li>Share with your friends</li>
          </ul>
          <div className="package-card__range mt-5 base--color">
          5 Entries
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
     
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Instagram</h4>
          <ul className="package-card__features mt-4">
            <li>Follow and like GlobusChain on instagram </li>
            {/* <li>Every Hour</li>
            <li>For 150 Hour</li>
            <li>
              Total 1500USD + <span className="badge base--bg">Capital</span>
            </li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">1 Entry</div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">YouTube</h4>
          <ul className="package-card__features mt-4">
            <li>Follow and like GlobusChain on YouTube</li>
            {/* <li>Every Day</li>
            <li>For Lifetime</li>
            <li>Lifetime Earning</li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">
            1 Entry
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
      <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
        <div
          className="package-card text-center bg_img"
          data-background="assets/images/bg/bg-4.png"
        >
          <h4 className="package-card__title base--color mb-2">Retweet</h4>
          <ul className="package-card__features mt-4">
            <li>Retweet GlobusChain pinned message on Twitter</li>
            {/* <li>Every Day</li>
            <li>For Lifetime</li>
            <li>Lifetime Earning</li> */}
          </ul>
          <div className="package-card__range mt-5 base--color">
            1 Entry
          </div>
          <a href="#0" className="cmn-btn btn-md mt-4">
            Attempt Task
          </a>
        </div>
        
      </div>
    </div>
    {/* row end */}

    {isConnected && (
    <div className="row mt-50">
      <div className="col-lg-12 text-center">
        <a onClick={referral} className="cmn-btn">
          Your Referral Code
        </a>
      </div>
    </div>
    )}
  </div>
</section>

    );
}